import { anatomy as t } from "../../node_modules/@zag-js/select/dist/index.mjs";
const o = t.extendWith("valueText");
export {
  o as anatomy
};
